import { db, collection, query, where, orderBy, getDocs } from "../../firebase";
import { data as constants } from "../../constants";
import InterviewerRepository from "../usecases/ports/interviewerRepository";
import { InterviewerType } from "../entities/interviewer";

export default class InterviewerFirebaseImpl implements InterviewerRepository {
  fetchInterviewers = async (): Promise<InterviewerType[]> => {
    try {
      let userList: InterviewerType[] = [];
      const userCollectionRef = collection(db, "user");

      const q = query(
        userCollectionRef,
        orderBy("createdAt", "desc"),
        where("accountStatus", "==", "active")
      );
      const userDocData = await getDocs(q);

      if (userDocData.empty && userDocData.metadata.fromCache) {
        throw new Error(constants.commonNetworkError);
      }

      userDocData.forEach((doc) => {
        const data = doc.data();
        userList.push({
          name: data.name,
          email: data.email,
        });
      });

      return userList;
    } catch (error) {
      throw error;
    }
  };
}
